import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-headers',
  templateUrl: './academic-headers.component.html',
  styleUrls: ['./academic-headers.component.scss']
})
export class AcademicHeadersComponent implements OnInit{

  retrievedData: any;
  retrievedData1: any;

ngOnInit(): void {
  this.retrievedData = localStorage.getItem('userName') ;
  this.retrievedData1 = localStorage.getItem('campusName') ;
}
logout(){
  const logoutPage =localStorage.getItem('logoutPage');
  if(logoutPage){
    window.location.href = logoutPage;
  }
}
}
